import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'findAttribute' })
export class FindAttributePipe implements PipeTransform {
    transform(attributes: any[], key: string): any {
        return attributes?.find(attr => attr.jsonProperty === key)?.value;
    }
}
